import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { CompanyCodesListWrapper } from './companycodes-list/CompanyCodesList'
import AccountPage from '../../modules/accounts/AccountPage'
import { AccountHeader } from '../../modules/accounts/AccountHeader'
import { Settings } from '../../modules/accounts/components/settings/Settings'
import { Overview } from '../../modules/accounts/components/Overview'

const companycodesBreadcrumbs: Array<PageLink> = [
  {
    title: 'CompanyCode Management',
    path: '/admin/pages/companycodes',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Account',
    path: '/admin/pages/companycodes/overview',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const CompanyCodesPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          // path='companycodes'
          index
          element={
            <>
              <PageTitle breadcrumbs={companycodesBreadcrumbs}>CompanyCodes list</PageTitle>
              <CompanyCodesListWrapper />
            </>
          }
        />

        <Route
          element={
            <>
              <AccountHeader />
              <Outlet />
            </>
          }
        >
          <Route
            path='overview'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
                <Overview />
              </>
            }
          />
          <Route
            path='settings'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Settings</PageTitle>
                <Settings />
              </>
            }
          />
          <Route index element={<Navigate to='/admin/pages/companycodes/overview' />} />
        </Route>

      </Route>
      <Route index element={<Navigate to='/admin/pages/companycodes' />} />
    </Routes>
  )
}

export default CompanyCodesPage
